module.exports = __webpack_public_path__ + "img/card-line.860eb1f0.svg";